import { FC } from 'react';
import Lottie from 'lottie-react';
import { Button, Stack, Typography } from '@mui/material';
import { useForceUpdate, noConnection } from '@vs-online-only-app/ui';

export const NetworkConnectionDownPlaceholder: FC = () => {
  const handleRetry = useForceUpdate();

  return (
    <Stack gap={2}>
      <Lottie style={{ height: '120px' }} animationData={noConnection} />
      <Stack>
        <Typography variant="h6" align="center">
          No internet connection.
        </Typography>
        <Typography variant="body2" align="center">
          Please check your connection and try again.
        </Typography>
      </Stack>
      <Button onClick={handleRetry} variant="outlined" fullWidth>
        Retry
      </Button>
    </Stack>
  );
};
